var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from 'aurelia-templating';
import { autoinject } from 'aurelia-dependency-injection';
import * as Enumerable from 'linq';
import { BaseModal, EntityTypes } from "../../../models/basics/basics.models";
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import { EnumUtilities } from "../../../utilities/enum-utilities";
var EntityFinder = /** @class */ (function (_super) {
    __extends(EntityFinder, _super);
    function EntityFinder(dialogService) {
        var _this = _super.call(this, dialogService) || this;
        _this.supportedEntityTypes = [];
        return _this;
    }
    EntityFinder.prototype.activate = function (model) {
        this.model = model;
        if (model) {
            this.filter = model.filter;
            this.supportedEntityTypes = model.supportedEntityTypes;
            this.allowSelection = model.allowSelection;
        }
    };
    EntityFinder.prototype.entityTypeName = function (x) {
        return EnumUtilities.getName(EntityTypes, x);
    };
    EntityFinder.prototype.getKeys = function (x) {
        return Enumerable.from(Object.keys(x[0])).where(function (a) { return x[0][a].isVisible; }).toArray();
    };
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], EntityFinder.prototype, "allowSelection", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], EntityFinder.prototype, "supportedEntityTypes", void 0);
    EntityFinder = __decorate([
        autoinject,
        __metadata("design:paramtypes", [DialogClientService])
    ], EntityFinder);
    return EntityFinder;
}(BaseModal));
export { EntityFinder };
